class BundleBuilder extends HTMLElement {
  constructor() {
    super();
    this.productWrapperSelector = '[js-product-wrapper]';
    this.selectProductBtnSelector = '[js-select-product-btn]';
    this.selectProductQuantitySelector = '[js-select-product-quantity]';
    this.quantityInputSelector = '[js-quantity-input]';
    this.incrementBtnSelector = '[js-quantity-increment]';
    this.decrementBtnSelector = '[js-quantity-decrement]';
    this.selectionBoxSelector = '[js-selection-box]';
    this.selectionBoxListSelector = '[js-selection-box-list]';

    this.selectionCountWrappers = this.querySelectorAll('[js-selection-count-wrapper]');
    this.selectionCounts = this.querySelectorAll('[js-selection-count]');
    this.addToCartBtns = this.querySelectorAll('[js-bundle-addToCart-btn]');
    this.comparePriceWrappers = this.querySelectorAll('[js-product-compare-price]');
    this.priceWrappers = this.querySelectorAll('[js-product-price]');
    this.bundleCompletedMsgs = this.querySelectorAll('[js-bundle-completed-msg]');
    this.bundleProcessMsgs = this.querySelectorAll('[js-bundle-processing-msg]');
    this.selectionRemainingCounts = this.querySelectorAll('[js-remaining-count]');

    this.totalBox = 3;
    this.products = [];

    this.addEventListener('click', (event) => {
      this.querySelectorAll(this.selectProductBtnSelector).forEach(selectProductBtn => {
        if(selectProductBtn.contains(event.target)) {

          const parent = selectProductBtn.closest(this.productWrapperSelector);
          const quantityField = parent.querySelector(this.quantityInputSelector);
          quantityField.stepUp();
     
          parent.classList.add('selected');

          this.addProductToBox(parent);

        }
      })

      this.querySelectorAll(this.decrementBtnSelector).forEach(decrementBtn => {
        if(decrementBtn.contains(event.target)) {
          const parent = decrementBtn.closest(this.productWrapperSelector);
          const currentProductId = Number(parent.dataset.productId);
          const quantityField = parent.querySelector(this.quantityInputSelector);
          quantityField.stepDown();

          this.removeProductFromBox(currentProductId, parent);
        }
      })

      this.querySelectorAll(this.incrementBtnSelector).forEach(incrementBtn => {
        if(incrementBtn.contains(event.target)) {
          const parent = incrementBtn.closest(this.productWrapperSelector);
          const quantityField = parent.querySelector(this.quantityInputSelector);
          quantityField.stepUp();
          this.addProductToBox(parent);

        }
      })

    })

    this.addToCartBtns.forEach(addToCartBtn => {
      addToCartBtn.addEventListener('click', (e) => {

        this.addToCartBtns.forEach(addToCartBtn => {
          addToCartBtn.classList.add('loading');
          addToCartBtn.querySelector('.loading__spinner').classList.remove('hidden');
       })

        const productsId = [];
        const products = [];
  
        this.products.forEach(item => {
          if(productsId.indexOf(item.id) === -1) {
            productsId.push(item.id)
            products.push({
              id: item.id,
              quantity: 1,
            })
          } else { 
            products[productsId.length - 1].quantity += 1;
          }
        })
        this.addToCart(products);
      })
    })

    

    document.addEventListener('renderBundleProduct:init', () => {
      this.updateAfterFilterApply();
    })

    this.createBox(this.totalBox);
  }

  updateAfterFilterApply() {
    this.fillProductInSelectionBox(this.products);
    
    this.products.forEach(product => {
      const selectedProductWrapper = this.querySelector(`${this.productWrapperSelector}[data-product-id="${product.id}"]`);
      const currentProducts = this.products.filter(product => product.id == Number(selectedProductWrapper.dataset.productId));
      selectedProductWrapper.classList.add('selected');
      selectedProductWrapper.querySelector(this.quantityInputSelector).value = currentProducts.length;
    })
  }

  removeProductFromBox(id, parent) {
    const otherProducts = this.products.filter(product => product.id !== id);
    const currentProducts = this.products.filter(product => product.id == id);
    currentProducts.splice(0, 1)
    if(currentProducts.length === 0) {
      parent.classList.remove('selected');
    }
    this.products = [...currentProducts, ...otherProducts];
    this.fillProductInSelectionBox(this.products);
  }

  addProductToBox(parent) {
    const imageUrl = parent.dataset.productImageUrl;
    const productId = Number(parent.dataset.productId);
    const title = parent.dataset.productTitle;
    const benefit = parent.dataset.productBenefit;
    const price = Number(parent.dataset.productPrice);
    const comparePrice = Number(parent.dataset.productComparePrice);

    this.products.push({
      id: productId,
      imageUrl,
      title,
      benefit,
      price,
      quantity: 1,
      comparePrice,
    })

    this.fillProductInSelectionBox(this.products);
  }


  createBox(number) {
    this.querySelector(this.selectionBoxListSelector).innerHTML = '';
    let productbox = '';
    for (let i = 0; i < number; i++) {
      productbox += `<div js-selection-box class="selection-box-item d-flex" data-index="${i}">
      <div class="selected-product-media">
          <img src="https://cdn.shopify.com/s/files/1/0847/5728/3136/files/Salud_Immunity_Hibiscus_Pouch_v22_e78a4fa3-8afe-46af-8d98-f407550a76e8.png?v=1700198754" alt="">
      </div>
      <div class="empty-selection">
          <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96" fill="none">
              <rect x="1.5" y="1.5" width="93" height="93" stroke="#442F2C" stroke-width="3" stroke-dasharray="6 6"/>
              <path opacity="0.1" d="M26 17V20.6858L26.4905 21.0063L26 21.487L26.1635 27.5766C26.872 37.993 28.289 59.3385 28.289 61.3897C28.289 63.4409 28.398 74.103 28.4525 79.1777C28.7795 79.1243 29.7605 79.0495 31.0684 79.1777C32.7034 79.3379 43.8213 80.1392 51.8327 79.9789C58.2418 79.8507 65.948 79.1777 69 78.8572C68.5095 70.7377 67.5612 53.954 67.692 51.7746C67.8228 49.5952 68.6185 30.6748 69 21.487L68.673 21.0063L69 20.6858V17C63.2776 17.1068 51.2441 17.2885 48.8897 17.1603C46.5354 17.0321 32.6489 17 26 17Z" fill="#442F2C"/>
          </svg>
      </div>
      <div class="selected-bundle-info">
          <h3 class="title">choose a flavor</h3>
          <div class="info"></div>
          <div class="prices">Reg. $25</div>
      </div>
  </div>`
    }
    this.querySelector(this.selectionBoxListSelector).insertAdjacentHTML('beforeend', productbox);
  }

  fillProductInSelectionBox(products) {
    this.createBox(this.totalBox);
    products.forEach((item, index) => {
      this.querySelector(`${this.selectionBoxSelector}[data-index="${index}"]`).innerHTML = '';
      this.querySelector(`${this.selectionBoxSelector}[data-index="${index}"]`).classList.add('filled');
      this.querySelector(`${this.selectionBoxSelector}[data-index="${index}"]`).setAttribute('data-product-id', item.id);
      this.querySelector(`${this.selectionBoxSelector}[data-index="${index}"]`).insertAdjacentHTML('beforeend', `<div class="selected-product-media">
              <img src="${item.imageUrl}">
          </div>
          <div class="empty-selection">
              <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96" fill="none">
                  <rect x="1.5" y="1.5" width="93" height="93" stroke="#442F2C" stroke-width="3" stroke-dasharray="6 6"/>
                  <path opacity="0.1" d="M26 17V20.6858L26.4905 21.0063L26 21.487L26.1635 27.5766C26.872 37.993 28.289 59.3385 28.289 61.3897C28.289 63.4409 28.398 74.103 28.4525 79.1777C28.7795 79.1243 29.7605 79.0495 31.0684 79.1777C32.7034 79.3379 43.8213 80.1392 51.8327 79.9789C58.2418 79.8507 65.948 79.1777 69 78.8572C68.5095 70.7377 67.5612 53.954 67.692 51.7746C67.8228 49.5952 68.6185 30.6748 69 21.487L68.673 21.0063L69 20.6858V17C63.2776 17.1068 51.2441 17.2885 48.8897 17.1603C46.5354 17.0321 32.6489 17 26 17Z" fill="#442F2C"/>
              </svg>
          </div>
          <div class="selected-bundle-info">
              <h3 class="title">${item.title}</h3>
              <div class="info">${item.benefit}</div>
              <div class="prices">$${item.price / 100}</div>
          </div>`)
    })
    this.updateStatus();
    this.updatePrice();
  }

  updatePrice() {
    let totalComparePrice = 0;
    this.products.forEach(product => {
      if(product.comparePrice) {
        totalComparePrice += product.comparePrice;
      }
    })

    let totalPrice = 0;
    this.products.forEach(product => {
      if(product.price) {
        totalPrice += product.price;
      }
    })

    // this.comparePriceWrappers.forEach(comparePriceWrapper => {
    //   comparePriceWrapper.innerHTML = `$${totalComparePrice / 100}`
    // })

    // this.priceWrappers.forEach(priceWrapper => {
    //   priceWrapper.innerHTML = `$${totalPrice / 100}`
    // })
  }

  updateStatus() {
    this.querySelectorAll(this.incrementBtnSelector).forEach(item => {
      item.classList.remove('disabled')
    })
    this.querySelectorAll(this.selectProductBtnSelector).forEach(item => {
      item.classList.remove('disabled')
    })

    this.selectionCountWrappers.forEach(selectionCountWrapper => {
      selectionCountWrapper.classList.remove('hidden');
    })
   
    this.addToCartBtns.forEach(addToCartBtn => {
      addToCartBtn.classList.add('hidden');
    })
  
    this.bundleCompletedMsgs.forEach(bundleCompletedMsg => {
      bundleCompletedMsg.classList.add('hidden');
    })
    this.bundleProcessMsgs.forEach(bundleProcessMsg => {
      bundleProcessMsg.classList.remove('hidden');
    })
    this.selectionCounts.forEach((selectionCount) => {
      selectionCount.innerHTML = `${this.products.length}/${this.totalBox}`;
    })

    this.selectionRemainingCounts.forEach((selectionRemainingCount) => {
      selectionRemainingCount.innerHTML = this.totalBox - this.products.length;
    })

    if(this.products.length === 0) {
      this.bundleProcessMsgs.forEach(bundleProcessMsg => {
        bundleProcessMsg.classList.add('hidden');
      })
    }

    if(this.products.length === this.totalBox) {
      this.querySelectorAll(this.incrementBtnSelector).forEach(item => {
        item.classList.add('disabled')
      })
      this.querySelectorAll(this.selectProductBtnSelector).forEach(item => {
        item.classList.add('disabled')
      })

      this.addToCartBtns.forEach(addToCartBtn => {
        addToCartBtn.classList.remove('hidden');
      })
     
      this.bundleCompletedMsgs.forEach(bundleCompletedMsg => {
        bundleCompletedMsg.classList.remove('hidden');
      })

      this.selectionCountWrappers.forEach(selectionCountWrapper => {
        selectionCountWrapper.classList.add('hidden');
      })
      this.bundleProcessMsgs.forEach(bundleProcessMsg => {
        bundleProcessMsg.classList.add('hidden');
      })
    }
  }

  async addToCart(products) {
    const requestBody = {
      items: products
    }

    const cartDrawer = document.querySelector('cart-drawer');
    requestBody.sections = cartDrawer.getSectionsToRender().map((section) => section.id);

    try {
      const resp = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        body: JSON.stringify(requestBody),
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await resp.json();

      this.addToCartBtns.forEach(addToCartBtn => {
        addToCartBtn.classList.remove('loading');
        addToCartBtn.querySelector('.loading__spinner').classList.add('hidden');
      })

      cartDrawer.renderContents(data);
      document.querySelector('cart-drawer').open();
  
    } catch(err){
      console.log({ err })
    }
  }

}


customElements.define('bundle-builder', BundleBuilder)